import { NgClass, TitleCasePipe } from "@angular/common";
import { ChangeDetectorRef, Component, Inject, OnInit } from "@angular/core";
import { AngularFireAnalytics } from "@angular/fire/compat/analytics";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { MatIcon } from "@angular/material/icon";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { Data, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { IonicModule } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { interval } from "rxjs";
import { bounceIn } from "src/app/animations/custom.animation";
import { CommonVariable } from "src/app/app.constants";
import { JackpotTriggersService } from "src/app/services/jackpot-triggers.service";
import { DisplayCurrencyPipe } from "../../../pipe/display-currency.pipe";
import { CheckWinningsRepositoryService } from "../check-winnings-repository.service";

@Component({
  selector: "app-convert-to-cash",
  templateUrl: "./convert-to-cash.component.html",
  styleUrls: ["./convert-to-cash.component.scss"],
  animations: [bounceIn],
  standalone: true,
  imports: [
    IonicModule,
    NgClass,
    MatProgressSpinner,
    MatIcon,
    DisplayCurrencyPipe,
    TitleCasePipe,
    TranslatePipe],
})
export class ConvertToCashComponent implements OnInit {
  optionType = "credit";
  isCashSelected = false;
  isCreditSelected = true;
  spinnerAnimation: boolean;
  progressBar: number;
  timer$: any;
  sub: any;
  proceed = true;
  cash;
  translatedToastMsg: any;
  selectedLanguage: string = "en";
  public disableConvertToCashButton: boolean;
  public preferredCurrency: string = CommonVariable.preferredCurrency
  public currencySymbol: "£";
  public credit: number;
  public zeronumber: string;
  public languageCode: string;
  public convertToCashData;
  public cashDesc: string;
  public creditDesc: string;
  userId: string;
  constructor(
    private analytics: AngularFireAnalytics,
    private checkWinningsRepositoryService: CheckWinningsRepositoryService,
    private changeDetectorRef: ChangeDetectorRef,
    private router: Router,
    public translate: TranslateService,
    private authService: AuthService,
    private jackpotTriggerService: JackpotTriggersService,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private matBottomSheet: MatBottomSheetRef<ConvertToCashComponent>
  ) {
    this.disableConvertToCashButton = false;
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        this.selectedLanguage = l;
        translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );

    this.authService.getConstantsMsg$?.subscribe((msg: any) => {
      this.translatedToastMsg = msg?.static_messages_pwa;
    });

    this.authService.userDetails$?.subscribe(
      (user: Data) => {
        this.preferredCurrency = user?.preferred_currency ?? CommonVariable.preferredCurrency;
        this.authService.getCurrencyList$?.subscribe((data: any) => {
          const CurrencyDetails = data?.details?.find((x: any) => x?.currency_code === this.preferredCurrency);
          this.currencySymbol =
            CurrencyDetails?.currency_symbol ?? CommonVariable.defaultCurrencySymbol;
          this.languageCode = user?.language_code ? user?.language_code : "en";
          this.jackpotTriggerService.getTranslatedData(this.languageCode).subscribe(
            (data) => {
              this.convertToCashData = data?.["convert-to-cash"];

              if (this.convertToCashData?.cash) {
                this.authService
                  .getDVFromString(this.convertToCashData?.cash)
                  .then((dvString: string) => {
                    if (dvString) {
                      this.cashDesc = dvString;
                    } else {
                      return "";
                    }
                  })
                  .catch((err) => {
                    return err;
                  });
              }

              if (this.convertToCashData?.credit) {
                this.authService
                  .getDVFromString(this.convertToCashData?.credit)
                  .then((dvString: string) => {
                    if (dvString) {
                      this.creditDesc = dvString;
                    } else {
                      return "";
                    }
                  })
                  .catch((err) => {
                    return err;
                  });
              }
            },
            (err) => {
              return err;
            }
          );
        });
      },
      (err) => {
        return err;
      }
    );
  }

  async ngOnInit() {
    await this.authService
      ?.getUid("ConvertToCashComponent")
      ?.then((uid) => {
        this.userId = uid;
        this.analytics.logEvent("convert_to_cash_screen", {
          userId: this.userId
        });
      })
      .catch((error) => {
        return error;
      });

    // tslint:disable-next-line:max-line-length
    this.credit = this.data?.preferred_currency?.credit_won_sum
      ? this.data?.preferred_currency?.credit_won_sum
      : this.data?.credit_won_sum;
    this.cash = this.credit / this.data?.credit_multiplier;
  }

  chooseOption(type: string) {
    this.optionType = type;
    if (type === "cash") {
      this.isCashSelected = true;
      this.isCreditSelected = false;
    } else if (type === "credit") {
      this.isCashSelected = false;
      this.isCreditSelected = true;
    }
  }
  creditToCashConversion() {
    if (this.disableConvertToCashButton) {
      return;
    }
    this.disableConvertToCashButton = true;
    if (this.isCashSelected) {
      this.matBottomSheet.disableClose = true;
      this.checkWinningsRepositoryService.getCreditToConversion(this.data?.encr_claim_event_id).subscribe(
        (data) => {
          this.progressBar = 100;
          this.sub?.unsubscribe();
          this.spinnerAnimation = false;
          this.proceed = false;
          this.changeDetectorRef.detectChanges();
          if (data?.status === "rejected") {
            this.disableConvertToCashButton = false;
            this.authService.getConstantsMsg(data?.error_code).then((translatedMsg) => {
              const defaultMsg = {
                message: {
                  line_1: "Something went wrong!",
                  line_2: "",
                },
                style: {
                  icon: "tick circle error.svg",
                  type: "Error",
                },
              };
              this.authService.showToastMessage(translatedMsg, defaultMsg);
            }).catch((err) => {
              this.disableConvertToCashButton = false;
              return err;
            });
            this.matBottomSheet.dismiss();
            return;
          }
          if (data && data?.response && data?.response?.status?.toLowerCase() === "success") {
            /* this.snackService.openSnackBar(
              "Your credit has been successfully swapped to cash",
              "",
              "custom-class-success",
              "Success"
            ); */
            /* const msg = this.translatedToastMsg?.["1039"]?.[this.selectedLanguage];
            this.authService.showToast(msg ? msg : "Your credit has been successfully swapped to cash", "Success", ""); */
            this.authService.getConstantsMsg("1039").then((translatedMsg) => {
              const defaultMsg = {
                message: {
                  line_1: "Your credit has been successfully swapped to cash",
                  line_2: "",
                },
                style: {
                  icon: "tick circle success.png",
                  type: "Success",
                },
              };
              this.authService.showToastMessage(translatedMsg, defaultMsg);
            }).catch((error) => {
              return error;
            });
            this.matBottomSheet.dismiss();
          if (!this.data?.encr_claim_event_id) return new Error('encr_claim_event_id is missing');
            this.router.navigateByUrl(`checkWinnings/breakdown/${this.data?.encr_claim_event_id}`);
          } else {
            this.disableConvertToCashButton = false;
            //this.snackService.openSnackBar("Credit Conversion Failed", "", "custom-class-error", "Error");
            /* const msg = this.translatedToastMsg?.["1040"]?.[this.selectedLanguage];
            this.authService.showToast(msg ? msg : "Credit Conversion Failed", "Error", ""); */
            this.authService.getConstantsMsg("1040").then((translatedMsg) => {
              const defaultMsg = {
                message: {
                  line_1: "Credit Conversion Failed",
                  line_2: "",
                },
                style: {
                  icon: "tick circle error.svg",
                  type: "Error",
                },
              };
              this.authService.showToastMessage(translatedMsg, defaultMsg);
            }).catch((error) => {
              return error;
            });

            this.matBottomSheet.dismiss();
          }
        },
        (err) => {
          return err;
        }
      );
    } else {
      /* const msg = this.translatedToastMsg?.["1041"]?.[this.selectedLanguage];
      this.authService.showToast(msg ? msg : "Awesome, you're keeping the credit! Visit the store now and see what you can buy", "Success", ""); */
      this.authService.getConstantsMsg("1041").then((translatedMsg) => {
        const defaultMsg = {
          message: {
            line_1: "Awesome, you're keeping the credit! Visit the store now and see what you can buy",
            line_2: "",
          },
          style: {
            icon: "tick circle info.svg",
            type: "Info",
          },
        };
        this.authService.showToastMessage(translatedMsg, defaultMsg);
      }).catch((error) => {
        return error;
      });
      this.matBottomSheet.dismiss();
      if (!this.data?.encr_claim_event_id) return new Error('encr_claim_event_id is missing');
      this.router.navigateByUrl(`checkWinnings/breakdown/${this.data?.encr_claim_event_id}`);
    }
  }
  startSpinner() {
    this.spinnerAnimation = true;
    this.progressBar = 0;
    this.timer$ = interval(20);
    this.sub = this.timer$.subscribe(
      (sec) => {
        this.progressBar = 0 + sec;
        this.changeDetectorRef.detectChanges();
      },
      (err) => {
        return err;
      }
    );
  }
}
